import api from "../../service/api";

export default {
  state: () => ({
    queryOrderHistoryData: {},
  }),
  mutations: {
    SET_QUERY_ORDER_HISTORY_DATA(state, opt) {
      state.queryOrderHistoryData = opt;
    },
    PUSH_QUERY_ORDER_HISTORY_DATA(state, data) {
      for (let i = 0; i < data.length; i++) {
        state.queryOrderHistoryData.data.push(data[i]);
      }
    },
  },
  actions: {
    async getQueryOrderHistory({ commit }, opt) {
      const queryOrderHistoryData = await api["queryOrderHistory"]({
        address: opt.address,
        pair: opt.pair,
        pageIndex: opt.pageIndex,
        pageSize: opt.pageSize,
      });

      commit("SET_QUERY_ORDER_HISTORY_DATA", queryOrderHistoryData);
    },
  },
  getters: {},
};
